import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntTerritorialsUnits } from "../../../../models/handBooks/territorialsUnits";

enum FormField {
    id, // Идентификатор территориальной единицы (обязательно)
    type, // Тип территориальной единицы (опционально)
    // Enum:
    // [REPUBLIC, REGION, AREA, CITY_OF_REPUBLICAN_SIGNIFICANCE, 
    // CITY_OF_REGIONAL_SIGNIFICANCE, CITY_OF_AREA_SIGNIFICANCE, 
    // URBAN_VILLAGE, VILLAGE, RURAL_DISTRICT, RURAL]
    code, // Уникальный код территориальной единицы (обязательно)
    nameKy, // Название территориальной единицы на кыргызском языке (обязательно)
    nameRu, // Название территориальной единицы на русском языке (обязательно)
    polygonJson, // Полигон в формате JSON (опционально)
    // Пример: {"type":"Polygon","coordinates":[...]}
    parentId, // Родительская территориальная единица (опционально)
    administrativeCenterId, // Административный центр территориальной единицы (опционально)
  
}

interface IProps {
    show: boolean;
    territorialUnit: EntTerritorialsUnits;
    onHide: () => void;
    onSubmit: (pos: EntTerritorialsUnits) => Promise<boolean>;
}

export const AddTerritorialUnitModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.nameKy, value: props.territorialUnit.nameKy },
            { name: FormField.nameRu, value: props.territorialUnit.nameRu },
            { name: FormField.code, value: props.territorialUnit.code },
            { name: FormField.type, value: props.territorialUnit.type },
            { name: FormField.parentId, value: props.territorialUnit.parentId },
            { name: FormField.administrativeCenterId, value: props.territorialUnit.administrativeCenterId },
        ]);
    }

    const setEntityFromFields = (): EntTerritorialsUnits => {
        let territorialUnit = _.cloneDeep(props.territorialUnit);
        territorialUnit.nameKy = form.getFieldValue(FormField.nameKy);
        territorialUnit.nameRu = form.getFieldValue(FormField.nameRu);
        territorialUnit.code = form.getFieldValue(FormField.code);
        territorialUnit.type = form.getFieldValue(FormField.type);
        territorialUnit.parentId = form.getFieldValue(FormField.parentId);
        territorialUnit.administrativeCenterId = form.getFieldValue(FormField.administrativeCenterId);
        return territorialUnit;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);
           
            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }
 
    return (
        <>
            <DraggableModal
                title={props.territorialUnit.id === 0 ? t('handbooks.territorial_units.add_territorial_units') : t('handbooks.territorial_units.edit_territorial_units')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Form.Item
                        label={ t('general.nameKy') }
                        name={FormField.nameKy}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={ t('general.nameRu') }
                        name={FormField.nameRu}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={ t('general.code') }
                        name={FormField.code}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={ t('general.type') }
                        name={FormField.type}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                </Form>
            </DraggableModal>
        </>
    );
}
